<template>
  <div class="mode1">
    <div class="example-main">
      <div class="example-title">格式要求：</div>
      <div class="example-list" :style="!is_express_addr ? 'height: 0' : ''">
        <div class="example-item">收货地址示例一： <span>201107-134123456782709，王生13412345678上海市闵行区南江燕路243临</span></div>
        <div class="example-item">收货地址示例三： <span>王生13412345678上海市闵行区南江燕路243临</span></div>
        <div class="example-item">收货地址示例三： <span>王生，13412345678，上海市闵行区南江燕路243临,000000</span></div>
        <div class="example-item" style="color: red;font-weight: bold;">无货源收货地址示例： <span>王生，13412345678，上海市闵行区南江燕路243临,单号YT123456789</span></div>
        <div class="example-item">订单编号：淘、猫、京、拼等平台订单编号，如无订单编号可随机填写</div>
        <div class="example-item">如遇东莞市、中山市、天门市、三沙市、儋州市、嘉峪关市等没有区的城市，区域可设置为“其他区”</div>
      </div>
      <el-button class="right" @click="jumpUrl">下单教程</el-button>
    </div>
    <div class="show-example" @click="is_express_addr = !is_express_addr">
      {{is_express_addr ? '收起' : '展开'}}使用说明
      <span class="iconfont icon-shang" :class="{'up': !is_express_addr}"></span>
    </div>

    <div class="address-main">
      <div class="address-title">收件人信息</div>
      <el-input
          type="textarea"
          :autosize="{ minRows: 6}"
          v-model="address"
          placeholder="订单编号(可不填)，姓名，电话，地址，快递单号(无货源专用)（中间用逗号分隔，回车键换行，一行一条~）
订单编号(可不填)，姓名，电话，地址，快递单号(无货源专用)
订单编号(可不填)，姓名，电话，地址，快递单号(无货源专用)
订单编号(可不填)，姓名，电话，地址，快递单号(无货源专用)"
          class="ant-input"/>
      <!-- 使用旧版解析checkbox -->
      <el-checkbox v-model="is_old_parse">使用旧版解析</el-checkbox>
      <div class="confirm-addr-btn" @click="recipeInfoBtn">完成添加</div>
    </div>
  </div>
</template>

<script>
import { parse } from '@/api/area-parse'
import smart from 'address-smart-parse'
import AddressParse from 'address-parse'
export default {
  name: "mode_1",
  props: {
    orderAddress: {
      type: String,
      default: ""
    }
  },
  data(){
    return{
      is_old_parse: false,
      address: "",
      is_express_addr: true,
      addressData: []
    }
  },
  watch: {
    orderAddress(val){
      if(val){
        this.address = val;
        this.recipeInfoBtn();
      }
    }
  },
  methods:{
    // 跳转到url
    jumpUrl(){
      window.open('https://g85nhv7weo.feishu.cn/file/boxcnDTS2Q6Ts4TB9nOiXKw6Nwc',"_blank");
    },
    // 生成下单地址
    recipeInfoBtn() {
      if (this.address === '') {
        this.$message.info('请输入内容1')
        return false
      }
      var list = this.address.split('\n')
      // 判断是否使用旧版解析
      if(this.is_old_parse){
        this.generateAddress(list)
      }else{
        this.generateAddressNew(list)
      }
      // this.generateAddress(list)
      // this.generateAddressNew(list)
    },
    // 获取最高解析度
    getRightAddress(data){
      let ind = 0,max = 0;
      for(let i = 0;i<data.length;i++){
        if(data[i].__parse > max){
          ind = i;
          max = data[i].__parse;
        }
      }
      return data[ind];
    },
    // 去除最后一位
    removeOrderNoLast(orderNo){
      while(orderNo.length > 5){
        let c = orderNo[orderNo.length-1];
        if(c<'0' || c>'9'){
          orderNo = orderNo.substring(0,orderNo.length-2);
        }else{
          break;
        }
      }
      return orderNo;
    },
    generateAddressNew(list) {
      var error_qty = 0
      var ok_qty = 0
      var error_text = ''
      for (var i = 0; i < list.length; i++) {
        let item = list[i];
        
        let index_chinese = /[\u4e00-\u9fa5]+/g.exec(item);
        if(index_chinese==null){
          continue;
        }
        // 处理订单编号
        let orderNum = ''
        if(index_chinese.index > 2){
          // 有订单编号
          orderNum = item.substring(0,index_chinese.index);
          // 去除最后一位
          orderNum= this.removeOrderNoLast(orderNum);
          // orderNo.push(orderNum)
          // this.orderNo.push(orderNum)
        }
        item = item.substring(index_chinese.index,item.length);
        let res = AddressParse.parse(item,true);
        res = this.getRightAddress(res);
        if (res.__parse < 1){
          error_qty++;
          continue;
        }
        ok_qty++;
        let bean = {
          addr: res.details,
          name: res.name,
          mobile: res.mobile == "" ? res.phone : res.mobile,
          phone: res.phone,
          order_no: orderNum,
          province: res.province,
          city: res.city,
          area: res.area,
          detail: res.details,
          zip_code: res.zip_code,
          address: res.province + res.city + res.area + res.details,
        }
        // console.log(res,bean)
        this.addressData.push(bean)
      }
      if (error_qty == 0) {
        this.address = ''
      }
      this.$emit("onAddress", {data: this.addressData, error_qty: error_qty, ok_qty: ok_qty})
    },
    generateAddress(list) {
      
      // this.addressData = []
      var error_qty = 0
      var ok_qty = 0
      var error_text = ''

      for (var i = 0; i < list.length; i++) {
        var text = list[i]
        // 判断是否是无货源
        var tis = text.split("单号");
        var remark = "";
        if(tis.length>1){
          text = tis[0];
          remark = tis[1];
          var sub = text.substr(text.length-1,1)
          if(sub==','||sub=='，'){
            text = text.substr(0,text.length-1)
          }
        }
        var substr = text.substr(text.length - 1, 1)
        if (substr == ',' || substr == '，') {
          var slice = text.slice(0, text.length - 1)
          var newAddress = slice.split(',,')
          if (newAddress.length > 0) {
            text = newAddress[0] + ',' + newAddress[1]
          }
        }
        var row = text
        text = text.replace(/\r\n/g, '')
        text = text.replace(/,/g, '，')
        text = text.replace(/其他区/g, '')
        var order_no = '00000000'
        if (text.trim() == '') {
          break
        } else {
          var status = 0
          var arr = text.split('，')
          if (arr.length == 0 || arr.length == 1) {
            status = 1
          } else if (arr.length == 2 || arr.length == 3 || arr.length == 4 || arr.length == 5) {
            order_no = arr[0]
            var obj = arr[0]
            if (/.*[\u4e00-\u9fa5]+.*$/.test(obj)) {
              order_no = '00000000'
            } else {
              text = text.replace(order_no, '')
            }
            status = 1
          }

          if (status == 1) {
            var parse_list = parse(text)
            // 无货源单号
            if(remark!=''){
              parse_list.remark = remark
            }
            console.log(parse_list)
            if (parse_list.mobile == '' && parse_list.phone != '') {
              parse_list.mobile = parse_list.phone
            }
            if (parse_list) {
              if (parse_list.area == '' || parse_list.name == '' || (parse_list.mobile == '' && parse_list.phone)) {
                error_text += row + '\r\n'
                error_qty++
              } else {
                if (parse_list) {
                  parse_list.phone = parse_list.mobile
                  if (!this.checkPhone(parse_list.phone) && !this.checkTel(parse_list.phone)) {
                    error_text += row + '\r\n'
                    error_qty++
                  } else {
                    parse_list.order_no = order_no
                    if (parse_list.province === parse_list.city) {
                      parse_list.address = parse_list.city + parse_list.area + parse_list.addr
                    } else {
                      parse_list.address = parse_list.province + parse_list.city + parse_list.area + parse_list.addr
                    }
                    var parse_list2 = parse(parse_list.address)
                    if (this.strlen(parse_list2.mobile) == 0) {
                      if (parse_list.name != '' && parse_list.mobile != '' && parse_list.province != '' && parse_list.city != '' && parse_list.area != '' && parse_list.addr != '') {
                        this.addressData.push(parse_list)
                        ok_qty++
                      } else {
                        error_text += row + '\r\n'
                        error_qty++
                      }
                    } else {
                      error_text += row + '\r\n'
                      error_qty++
                    }
                  }
                }
              }
            } else {
              error_text += row + '\r\n'
              error_qty++
            }
          } else {
            error_text += row + '\r\n'
            error_qty++
          }
        }
      }
      if (error_qty > 0) {
        this.msg_type = 'error';
        this.address = error_text;
      } else {
        this.msg_type = 'success';
        this.address = '';
      }
      console.log(this.addressData)
      this.$emit("onAddress", {data: this.addressData, error_qty: error_qty, ok_qty: ok_qty})
      // this.address_msg = '验证失败 ' + error_qty + ' 条，成功 ' + ok_qty + ' 条，总计 ' + (error_qty + ok_qty) + ' 条'
      // setTimeout(() => {
      //   this.toggleSelection(this.addressData)
      // }, 500)
    },

    strInfo(address) {
      address = address || ''
      const parse = {
        name: '',
        mobile: '',
        phone: '',
        address: ''
      }
      // 去除空格...
      address = address.replace(/\r\n/g, ' ').replace(/\n/g, ' ').replace(/\t/g, ' ')
      address = address.replace(/\s+/g, '')
      // 自定义去除关键字，可自行添加
      const search = ['地址', '收货地址', '收货人', '收件人', '收货', '邮编', '电话', '：', ':', '；', ';', '，', ',', '。', ' ']
      search.forEach(str => {
        address = address.replace(new RegExp(str, 'g'), ' ')
      })
      // 多个空格replace为一个
      address = address.replace(/ {2,}/g, ' ')
      // 整理电话格式
      address = address.replace(/(\d{3})-(\d{4})-(\d{4})/g, '$1$2$3')

      address = address.replace(/(\d{3}) (\d{4}) (\d{4})/g, '$1$2$3')

      const mobileReg = /(86-[1][0-9]{10})|(86[1][0-9]{10})|([1][0-9]{10})/g
      const mobile = mobileReg.exec(address)
      if (mobile) {
        parse.mobile = mobile[0]
        address = address.replace(mobile[0], ' ')
      }
      // 电话
      const phoneReg = /(([0-9]{3,4}-)[0-9]{7,8})|([0-9]{12})|([0-9]{11})|([0-9]{10})|([0-9]{9})|([0-9]{8})|([0-9]{7})/g
      const phone = phoneReg.exec(address)
      if (phone) {
        parse.phone = phone[0]
        address = address.replace(phone[0], ' ')
      }
      address = address.replace(/ {2,}/, ' ')
      var new_addr = address.split(' ')
      parse.name = new_addr[0]
      parse.address = new_addr[1]
      return parse
    },

    strlen(str) {
      var len = 0
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i)
        // 单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          len++
        } else {
          len += 2
        }
      }
      return len
    },
    checkPhone(phone) {
      return (/^1(3|4|5|6|7|8|9)d{9}$/.test(phone))
    },
    checkTel(s) {
      var patrn = /^[+]{0,1}(\d){1,3}[ ]?([-]?((\d)|[ ]){1,12})+$/
      if (!patrn.exec(s)) return false
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.right{
  width: 150px;
  height: 100px;
  font-size: 20px;
  background-color: #2071b8;
  color: white;
  float: right;
  position: relative;
  top: -100px;
}
.mode1{
  .example-main{
    .example-title{
      color: #0f375a;
      font-size: 14px;
      font-weight: bolder;
      margin-bottom: 10px;
    }

    .example-list{
      height: 112px;
      overflow: hidden;
      transition: all 1s ease;

      .example-item{
        color: #878787;
        margin-bottom: 8px;

        &:hover span{
          color: #0f375a;
          cursor: pointer;
        }
      }
    }
  }
  .show-example{
    color: #0f375a;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 20px 0;

    .iconfont{
      font-weight: bold;
      transition: all 1s ease;
    }
    .up{
      transform: rotateZ(180deg);
    }
  }
  .address-main{
    margin-bottom: 20px;

    .address-title{
      font-size: 16px;
      font-weight: bolder;
      color: #0f375a;
      margin-bottom: 10px;
    }

    .confirm-addr-btn{
      margin-top: 15px;
      width: 120px;
      height: 40px;
      background-color: #0f375a;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/order/components/mode/mode_1.vue